import { CloseIconButton } from 'shared/ui/buttons/iconButtons/closeButton';
import { PenIconButton } from 'shared/ui/buttons/iconButtons/penButton';

import { TopButtonsContainer } from '../styles';
import { Flex } from 'shared/ui/flex';
import { FC } from 'react';
import { OrderDetailHeaderProps } from '../types';
import { useOrderDetailHeader } from 'widgets/orderDetail/lib/hooks/useOrderDetailHeader';
import { OrderDetailHeaderTitle } from './orderDetailHeaderTitle';
import { OrderDetailHeaderTimer } from './orderDetailHeaderTimer';
import { useEscape } from 'shared/lib/modal';
import { useResize } from 'app/lib/hooks/useResize';

export const OrderDetailHeader: FC<OrderDetailHeaderProps> = ({
	includeCloseButton = false,
	includePenButton = false,
	roundedBorders = false,
	open,
	close,
	order,
}) => {
	const { variant, hasEdit } = useOrderDetailHeader(order);

	const hasEditIcon = hasEdit && includePenButton;

	useEscape(() => {
		if (!document.getElementById('booking-form')?.hasChildNodes()) {
			close();
		}
	});

  const { 
    isScreenSm
  } = useResize();

	return (
		<TopButtonsContainer
			$colorVariant={variant}
			$roundedBorders={roundedBorders}
		>
			<Flex $gap="4px" $alignItems="center">
				<OrderDetailHeaderTitle order={order} variant={variant} />
				<OrderDetailHeaderTimer order={order} variant={variant} />
			</Flex>
			<Flex>
				{(hasEditIcon&&isScreenSm) && (
					<PenIconButton
						onClick={open}
						light={variant !== 'default'}
					/>
				)}
				{includeCloseButton && (
					<CloseIconButton
						onClick={close}
						id="close-details"
						light={variant !== 'default'}
					/>
				)}
			</Flex>
		</TopButtonsContainer>
	);
};
